<div class="separator-section d-flex align-items-center">
  <div class="separator-line"></div> <div class="separator-message mx-3">{{ text }}</div>
  <div class="separator-line"></div>
</div>
